import { render } from "./InvoiceApproval.vue?vue&type=template&id=6dd32600&scoped=true"
import script from "./InvoiceApproval.vue?vue&type=script&lang=js"
export * from "./InvoiceApproval.vue?vue&type=script&lang=js"

import "./InvoiceApproval.vue?vue&type=style&index=0&id=6dd32600&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd32600"]])

export default __exports__